import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import DOList from './views/DOList.vue';
import AutoOne from './views/process/AutoOne.vue';
import AutoTwo from './views/process/AutoTwo.vue';
import OpenList from './views/OpenList.vue';
import PickList from './views/PickList.vue';
import Login from './views/Login.vue';


Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/do',
      component: DOList,
      meta: { requiresAuth: true }
    },
    {
      path: '/do/config/auto/1',
      component: AutoOne,
      meta: { requiresAuth: true }
    },
    {
      path: '/do/config/auto/2',
      component: AutoTwo,
      meta: { requiresAuth: true }
    },
    {
      path: '/do/config/manual/1',
      component: DOList,
      meta: { requiresAuth: true }
    },
    {
      path: '/do/config/manual/2',
      component: DOList,
      meta: { requiresAuth: true }
    },
    {
      path: '/do/config/manual/3',
      component: DOList,
      meta: { requiresAuth: true }
    },
    {
      path: '/picklist-open',
      component: OpenList,
      meta: { requiresAuth: true }
    },
    {
      path: '/picklist',
      component: PickList,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/profile',
      name: 'profile',
      meta: { requiresAuth: true },
      // lazy-loaded
      component: () => import('./views/Profile.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: { requiresAuth: true },
      // lazy-loaded
      component: () => import('./views/BoardAdmin.vue')
    },
    {
      path: '/mod',
      name: 'moderator',
      meta: { requiresAuth: true },
      // lazy-loaded
      component: () => import('./views/BoardModerator.vue')
    },
    {
      path: '/user',
      name: 'user',
      meta: { requiresAuth: true },
      // lazy-loaded
      component: () => import('./views/BoardUser.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  //Change here
  const publicPages = ['/login', '/home'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
  if (authRequired && !loggedIn) {
    next({
      path: '/login',
      //query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
})
